import getWidgetByName from "../requests";
import { SeriesListings } from "../series/entities";

const getEditorsChoiceCarouselWidget = payload =>
  getWidgetByName("editorschoicecarousel", payload).then(SeriesListings);

export { getEditorsChoiceCarouselWidget };
